import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from '@p81-common/ui';
import { EmptyState, Loading } from 'components/common/Elements/Elements';

import { useTableSettings } from './helpers/tableSettings';
import { useEdgeDataGrid } from './helpers/useEdgeDataGrid';
import EdgeFilters from './parts/EdgeFilters';
import EdgeDataGrid from './parts/EdgeDataGrid';
import PartialDataBanner from './parts/PartialDataBanner';

const EdgesList = () => {
  const { t } = useTranslation('edges');
  const { tableConfig } = useTableSettings();
  const useDataGridResultProps = useEdgeDataGrid(tableConfig);
  const { dataConection, loader, failedDrs } = useDataGridResultProps;

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <PageTitle
        title={t('EDGES_LIST.PAGE_TITLE')}
        subtitle={t('EDGES_LIST.PAGE_SUBTITLE')}
        sx={{ marginBottom: 5 }}
      />
      <PartialDataBanner failedDrs={failedDrs} />
      <EdgeFilters useDataGridResultProps={useDataGridResultProps} />
      <EdgeDataGrid useDataGridResultProps={useDataGridResultProps} />
    </>
  );
};

export default EdgesList;
